import { useState, useEffect, useMemo } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import PrivacyPolicyContent from "../../components/PrivacyPolicyContent/PrivacyPolicyContent";
import { fetchTermsAndConditions } from "../../services/termsApi";
import { normalizeTermsDisplay } from "../../util/termsHelpers";
import "./TermCondition.scss";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";

function TermCondition() {
  const [carousalStatus, setCarousalStatus] = useState(true);
  const [termsResponse, setTermsResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTerms = async () => {
      try {
        const terms = await fetchTermsAndConditions();
        setTermsResponse(terms);
      } catch (error) {
        console.error("Failed to load terms and conditions", error);
        setTermsResponse(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadTerms();
  }, []);

  const termsDisplay = useMemo(
    () => normalizeTermsDisplay(termsResponse),
    [termsResponse],
  );

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  if (isLoading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    );
  }

  return (
    <div className="Term_Condition_main_container">
      <Seo {...PAGE_SEO.terms} />
      <div className="Term_Condition_Page">
        <Header handleClick={handleClick} />
        <PrivacyPolicyContent policy={termsDisplay} />
      </div>
      <Footer />
    </div>
  );
}

export default TermCondition;
